import { useState } from 'react';
import { useEditLesson } from 'hooks/useEditLesson';
import { useCreateLessonVersion } from 'hooks/useCreateLessonVersion';
import { useUpdateLessonImage } from 'hooks/useUpdateLessonImage';
import { LessonForm } from "components/views/editor/models/LessonForm";

export const useUpdateVrLesson = () => {
    const { editLesson } = useEditLesson();
    const { createLessonVersion } = useCreateLessonVersion();
    const { updateLessonImageFromFile } = useUpdateLessonImage();
    const [isUpdating, setIsUpdating] = useState(false);

    const updateVrLesson = async (
        lessonId: string,
        lessonFormData: LessonForm,
        currentLanguage: string,
        editor: any
    ): Promise<boolean> => {
        setIsUpdating(true);
        try {
            const editLessonResponse = await editLesson({
                lessonId,
                lessonName: lessonFormData.lessonName,
                tagA: lessonFormData.tagA,
                tagB: lessonFormData.tagB
            });
            if (!editLessonResponse?.success) return false;

            const nodesData = editor && editor.nodes.length > 0 ? editor.toCustomJSON() : null;
            const newVersionResponse = await createLessonVersion({
                lessonId,
                language: currentLanguage,
                name: lessonFormData.lessonVersionName,
                description: lessonFormData.description,
                maxPoints: lessonFormData.maxPoints,
                shuffleAnswers: lessonFormData.shuffleAnswers,
                jsonConfig: nodesData?.jsonConfig ?? null,
                nodes: nodesData?.nodes ?? null,
                connections: nodesData?.connections ?? null,
                feedback: lessonFormData.feedback
            });
            if (!newVersionResponse?.success || !newVersionResponse.data) return false;

            if (lessonFormData.image) {
                const imageUpdateSuccess = await updateLessonImageFromFile(
                    lessonId,
                    lessonFormData.image.file
                );
                if (!imageUpdateSuccess) return false;
            }
            return true;
        } finally {
            setIsUpdating(false);
        }
    };

    return { updateVrLesson, isUpdating };
};
